import React, { useState ,useEffect} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ColorVisionGame.css";

const ColorVisionGame = () => {

  const navigate = useNavigate();
  useEffect(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }, []);
  
  const [index, setIndex] = useState(0);
  const [selected, setSelected] = useState(null);
  const [page, setPage] = useState("game");

  const [correct, setCorrect] = useState(0);
  const [wrong, setWrong] = useState(0);
  const [responses, setResponses] = useState([]);

  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState(null);

  // ================= DATA =================
  const plates = [
  { plate: 1, image: "/plates/plate1.png", correct: 12, options: [12, 8, 6, 3] },
  { plate: 2, image: "/plates/plate2.png", correct: 8, options: [10, 3, 8, 6] },
  { plate: 3, image: "/plates/plate3.png", correct: 6, options: [12, 8, 6, 9] },
  { plate: 4, image: "/plates/plate4.png", correct: 29, options: [12, 58, 76, 29] },
  { plate: 5, image: "/plates/plate5.png", correct: 57, options: [57, 22, 63, 95] },
  { plate: 6, image: "/plates/plate6.png", correct: 5, options: [6, 8, 3, 5] },
  { plate: 7, image: "/plates/plate7.png", correct: 3, options: [9, 7, 5, 3] },
  { plate: 8, image: "/plates/plate8.png", correct: 15, options: [74, 21, 14, 15] },
  { plate: 9, image: "/plates/plate9.png", correct: 74, options: [61, 78, 74, 33] },
  { plate: 10, image: "/plates/plate10.png", correct: 2, options: [45, 2, 9, 4] },
  { plate: 11, image: "/plates/plate11.png", correct: 6, options: [9, 3, 6, 5] },

  { plate: 12, image: "/plates/plate12.png", correct: 97, options: [97, 11, 41, 92] },
  { plate: 13, image: "/plates/plate13.png", correct: 45, options: [16, 46, 10, 45] },
  { plate: 14, image: "/plates/plate14.png", correct: 5, options: [6, 3, 7, 5] },
  { plate: 15, image: "/plates/plate15.png", correct: 7, options: [6, 4, 9, 7] },
  { plate: 16, image: "/plates/plate16.png", correct: 16, options: [42, 16, 24, 14] },
  { plate: 17, image: "/plates/plate17.png", correct: 73, options: [39, 15, 73, 25] },
  { plate: 18, image: "/plates/plate18.png", correct: 26, options: [96, 26, 9, 69] },
  { plate: 19, image: "/plates/plate19.png", correct: 42, options: [10, 42, 12, 21] },
  { plate: 20, image: "/plates/plate20.png", correct: 35, options: [42, 35, 62, 85] }
  
];

  // ================= SELECT (AUTO NEXT) =================
  const handleSelect = (opt) => {

    const current = plates[index];
    const isCorrect = opt === current.correct;

    if (isCorrect) setCorrect(prev => prev + 1);
    else setWrong(prev => prev + 1);

    const updatedResponses = [
      ...responses,
      {
        plate: current.plate,
        userSelection: opt,
        correctOption: current.correct,
         type: "ishihara" 
      }
    ];

    setResponses(updatedResponses);
    setSelected(opt);

    // 🔥 AUTO NEXT
    setTimeout(() => {
      setSelected(null);

      if (index + 1 < plates.length) {
        setIndex(prev => prev + 1);
      } else {
        finishTest(updatedResponses, correct + (isCorrect ? 1 : 0));
      }
    }, 800);
  };

  // ================= LEADERBOARD =================
  const fetchLeaderboard = async () => {
    try {
      const email = localStorage.getItem("rg_email");

      const res = await axios.get(`/colorvision-leaderboard?email=${email}`);

      setLeaderboard(res.data.leaderboard || []);
      setUserRank(res.data.userRank);

    } catch (e) {
      console.log(e);
    }
  };

  // ================= FINISH =================
  const finishTest = async (finalResponses, finalScore) => {

  setPage("result");

  const email = localStorage.getItem("rg_email");
  const name = localStorage.getItem("rg_name") || "";

  console.log("🚀 BEFORE SEND");
  console.log("Responses:", finalResponses);
  console.log("Type:", typeof finalResponses);
  console.log("Is Array:", Array.isArray(finalResponses));

  try {
    const res = await axios.post(
      "/save-color-vision",
      {
        name,
        email,
        score: finalScore,
        total: plates.length,
        responses: finalResponses   // ✅ CLEAN (no stringify needed)
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    console.log("✅ SERVER RESPONSE:", res.data);

    await fetchLeaderboard();

  } catch (e) {
    console.log("🔥 ERROR:", e.response?.data || e.message);
  }
};

  // ================= RESULT =================
  const getResultType = () => {
    if (correct >= plates.length - 2) return "Normal Vision ✅";
    if (correct >= plates.length / 2) return "Mild Deficiency ⚠️";
    return "Color Vision Deficiency ❌";
  };

  // ================= UI =================
  return (
    <div className="cv-game-container">

      {page === "game" && (
        <>
          <h2 className="cv-progress">
            Plate {index + 1} / {plates.length}
          </h2>

          <div className="cv-plate-box">
            <img
              src={plates[index].image}
              alt="plate"
              className="cv-plate-img"
              onError={(e) => {
                e.target.src = "/plates/plate1.png"; // fallback
              }}
            />
          </div>

          <div className="cv-options">
            {plates[index].options.map((opt, i) => (
              <button
                key={i}
                className={`cv-option-btn 
                  ${selected === opt ? 
                    (opt === plates[index].correct ? "correct" : "wrong") 
                    : ""}`}
                onClick={() => handleSelect(opt)}
              >
                {opt}
              </button>
            ))}
          </div>
        </>
      )}

      {page === "result" && (

        <div className="result-big-container">

          <div className="leaderboard-box">
            <h3>Leaderboard</h3>

            <table>
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Name</th>
                  <th>Score</th>
                  <th>Medal</th>
                </tr>
              </thead>

              <tbody>
                {leaderboard.slice(0,5).map((p, i) => {

                  let medal = "";
                  if (i === 0) medal = "🥇";
                  else if (i === 1) medal = "🥈";
                  else if (i === 2) medal = "🥉";

                  return (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{p.name}</td>
                      <td>{p.score}</td>
                      <td>{medal}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {userRank && (
              <div className="your-rank-box">
                Rank: {userRank.rank} <br/>
                Score: {correct}/{plates.length}<br/>
                Percentile: {userRank.percentile}%
              </div>
            )}
          </div>

          <div className="results-box">
            <h2>Your Result</h2>

            <p>Score: {correct} / {plates.length}</p>
            <p>{getResultType()}</p>

            <button onClick={() => window.location.reload()}>
              Try Again
            </button>

            <button onClick={() => navigate("/dashboard-login")}>
              Exit
            </button>
          </div>

        </div>
      )}

    </div>
  );
};

export default ColorVisionGame;